export const GET_KITCHEN_AREAS = 'providers/settings/KitchenAreas/GET_KITCHEN_AREAS';
export const GET_KITCHEN_AREAS_PAGINATION = 'providers/settings/KitchenAreas/GET_KITCHEN_AREAS_PAGINATION';
export const GET_KITCHEN_AREA_DETAILS = 'providers/settings/KitchenAreas/GET_KITCHEN_AREA_DETAILS';
export const CREATE_KITCHEN_AREA = 'providers/settings/KitchenAreas/CREATE_KITCHEN_AREA';
export const UPDATE_KITCHEN_AREA = 'providers/settings/KitchenAreas/UPDATE_KITCHEN_AREA';
export const DISABLE_KITCHEN_AREA = 'providers/settings/KitchenAreas/DISABLE_KITCHEN_AREA';
